import * as React from "react";
import type { ButtonProps as AriaButtonProps } from "react-aria-components";
import { Button as AriaButton } from "react-aria-components";

export default function Button(props: AriaButtonProps): React.ReactElement {
  const { children, ...rest } = props;

  return <AriaButton {...rest}>{children}</AriaButton>;
}
